import * as actionTypes from "../action-types";

// Hydrate from localStorage at boot so a page reload (e.g. coming back from a
// PayU/bharatdarshan.shop redirect) doesn't briefly appear as "logged out"
// while the getCustomerDetails saga finishes.
const hydrateCustomerDetails = () => {
    try {
        if (typeof window === 'undefined') return null;
        if (!localStorage.getItem('token')) return null;
        const raw = localStorage.getItem('customerData');
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (_) { return null; }
};

const initialState = {
    customerDetails: hydrateCustomerDetails(),
    milanSathiCustomerDetails: null,
    isLoginModalOpen: false,
    isSignupModalOpen: false,
    isForgetPasswordModalOpen: false,
};

const authReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.TOGGLE_LOGIN_MODAL:
            return { ...state, isLoginModalOpen: payload };

        case actionTypes.TOGGLE_SIGNUP_MODAL:
            return { ...state, isSignupModalOpen: payload };

        case actionTypes.TOGGLE_FORGET_PASSWORD_MODAL:
            return { ...state, isForgetPasswordModalOpen: payload };

        case actionTypes.SET_CUSTOMER_DETAILS:
            return { ...state, customerDetails: payload };

        case actionTypes.SET_MILAN_SATHI_CUSTOMER_DETAILS:
            return { ...state, milanSathiCustomerDetails: payload };

        default:
            return state;
    }
};

export default authReducer;